import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { JsonApiService } from './api/json-api.service'
import { ProductApiService } from './api/product-api.service'
import { AuthApiService } from './api/auth-api.service'
import { AseguradoraApiService } from './api/aseguradora-api.service'
import { MarcaApiService } from './api/marca-api.service'
import { CitaApiService } from './api/cita-api.service'
import { UploadApiService } from './api/upload-api.service'
import { RecepcionApiService } from './api/recepcion-api.service'
import { OrdenServicioApiService  } from './api/orden-servicio.service';
import { ValuacionApiService  } from './api/valuacion-api.service';
import { CotizacionApiService  } from './api/cotizacion-api.service';
import { PresupuestoApiService  } from './api/presupuesto-api.service';
import { ReparacionApiService  } from './api/reparacion-api.service';
import { TerminadaApiService  } from './api/terminada-api.service';
import { EntregadaApiService  } from './api/entregada-api.service';
import { CatalogoApiService } from './api/catalogo-api.service';
import { ComprasApiService  } from './api/compras-api.service';
import { PagosApiService  } from './api/pagos-api.service';
import { FacturacionApiService  } from './api/facturacion-api.service';
import { AlmacenApiService  } from './api/almacen-api.service';
import { ReportesApiService  } from './api/reportes-api.service';
import { ConfigService } from './api/config.service';
import { LayoutService } from '../shared/layout/layout.service'
import { UserService } from '../shared/user/user.service'
import { VoiceControlService } from '../shared/voice-control/voice-control.service'
import { SoundService } from '../shared/sound/sound.service';
import { EfectivoReembolsableService } from './api/efectivo-reembolsable.service';

import { throwIfAlreadyLoaded } from './guards/module-import-guard';
import {VoiceRecognitionService} from '../shared/voice-control/voice-recognition.service';
import {TabsModule, ProgressbarModule, TooltipModule, BsDropdownModule, AlertModule} from 'ngx-bootstrap';
import { Cotizacion } from 'app/core/model/classes/cotizacion';
import { ProveedorComponent  } from 'app/+catalogo/proveedores/proveedor.component';
import { ExistenciasApiService } from './api/existencias.service';
import { InventarioService } from './api/inventario.service';
import { QuillModule } from "ngx-quill";
import { OrdenServicioComentariosService } from './api/comentarios-api.service';


@NgModule({
  imports: [
    CommonModule,
    QuillModule,

    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    AlertModule.forRoot(),
    TabsModule.forRoot(),
  ],
  exports: [HttpClientModule],
  declarations: [],
  providers: [
    JsonApiService,
    ProductApiService,
    AuthApiService,
    AseguradoraApiService,
    UploadApiService,
    MarcaApiService,
    CitaApiService,
    RecepcionApiService,
    OrdenServicioApiService,
    ValuacionApiService,
    PresupuestoApiService,
    CotizacionApiService,
    ReparacionApiService,
    TerminadaApiService,
    EntregadaApiService,
    CatalogoApiService,
    ComprasApiService,
    PagosApiService,
    AlmacenApiService,
    FacturacionApiService,
    EfectivoReembolsableService,
    ReportesApiService,
    ExistenciasApiService,
    InventarioService,
    LayoutService,
    UserService,
    VoiceControlService,
    VoiceRecognitionService,
    SoundService,
    ConfigService,
    OrdenServicioComentariosService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/core.module.ts